export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Home.vue?vue&type=template&id=a72746ec&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/Home.vue?vue&type=template&id=a72746ec&scoped=true&
// module id = 260
// module chunks = 1